<div class="container-fluid" [ngClass]="A04CDE== null ? 'advanced-mt-4' : 'advanced-mt-0'">

  <!-- MODAL -->
  <ng-template #contenido let-modal>
    <div class="modal-header">
      <h4 class="modal-title"></h4>
      <button type="button" class="btn-close btn-rounded " data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body">
      <app-advancedtable [WsURL]=strWsURLModal [WsLlaves]=WsLlavesModal (RetornoModal)=RetornoModalLista($event)
        [mostrarModal]=true>
      </app-advancedtable>
      <div *ngIf="currentPDF">
        <object [data]="getSafeUrl()" type="application/pdf" width="100%" height="600px">
        </object>
      </div>
    </div>
  </ng-template>
  <!-- END MODAL -->


  <!-- MODAL campo -->
  <ng-template #contenidocampo let-modal>
    <div class="modal-header">
      <h4 class="modal-title"></h4>
      <button type="button" class="btn-close btn-rounded " data-bs-dismiss="modal" aria-label="Close"
        (click)="modal.dismiss()"></button>
    </div>
    <div class="modal-body" style="padding-bottom: 8.4px;padding-top: 0px;">
      <app-campo [form_template]="form_template$  | async" [strListener]="strEventListener"
        [blnMostrarBusqueda]="false && tipo_pantalla!='REPORTE'" [TipoPantalla]="tipo_pantalla"
        (cerrar)="cerrarmodal($event)" [ToolbarMS]=" this.toolbarcampomodal" [Modal]="true">
      </app-campo>
      <div *ngIf="currentPDF">
        <object [data]="getSafeUrl()" type="application/pdf" width="100%" height="600px">
        </object>
      </div>
    </div>
  </ng-template>
  <!-- END MODAL -->

  <!-- BEGIN Mantenimiento Interno -->
  <div *ngIf="this.MsDetalle=='S' && this.WsMsDataInterno != '' ">
    <app-simple-ms [WsData]=this.WsMsDataInterno (CerrarMsInterno)="EventoCerrarMSInterno($event)"></app-simple-ms>
  </div>
  <!-- END Mantenimiento Interno -->

  <!-- BEGIN Toolbar -->

  <div class="row mb-3" *ngIf="this.WsMsDataInterno == ''">
    <div class="col-md-12">
      <div class="card mb-0" style="background-color: transparent;">
        <div class="card-body" style="padding: 0.5em;">
          <div class="row align-items-center">
            <div class="col-md-6 col-sm-12">
              <ng-container *ngIf="!this.mostrarbreitem">
                <ng-container *ngIf="A04CDE==null; else wizard">
                  <div style="padding-left: 1em" class="mb-1">
                    <h4 class="mb-0 letra-azul">{{TituloPantalla}}</h4>
                    <ol class="breadcrumb m-0" style="padding: 0">
                      <li class="breadcrumb-item"><b>Compa&ntilde;&iacute;a:</b> {{companiaActual}}</li>
                      <li class="breadcrumb-item"><b>Sede:</b> {{sedeActual}}</li>
                    </ol>
                  </div>
                </ng-container>
                <ng-template #wizard>
                  <ol class="breadcrumb m-0">
                    <li class="breadcrumb-item">{{TituloPantalla}}</li>
                    <li class="breadcrumb-item active"><b>{{A04CDE}}</b></li>
                  </ol>
                </ng-template>
              </ng-container>
              <div class="page-title-right" *ngIf="this.mostrarbreitem">
                <ol class="breadcrumb m-0">
                  <li class="breadcrumb-item active"><b>{{this.TituloPantalla}} </b></li>
                </ol>
              </div>
            </div>
            <div class="col-md-6 col-sm-12" style="text-align: end">

              <ng-container *ngIf="this.toolbar">
                <div class="d-inline-block bloque mb-1" *ngFor="let boton of this.toolbar[0].NORMALES">
                  <div ngbDropdown class="d-inline-block" *ngIf="boton.Evento == 'IMPRIMIR';else otrosBotones">
                    <button type="button" title="{{boton.Tooltip}}" id="{{boton.Evento}}" name="{{boton.Evento}}"
                      class="btn blanco btn-label waves-light" ngbDropdownToggle
                      [ngStyle]="{'background-color': boton.class }">
                      <i class="fas fa-print label-icon" style="pointer-events:none ;"></i>
                      {{boton.boton}}
                    </button>
                  </div>

                  <ng-template #otrosBotones>

                    <button type="button" title="{{boton.Tooltip}}" id="{{boton.Evento}}" name="{{boton.Evento}}"
                      (click)="EventoClickToolbar($event, boton.URL)" class="btn blanco btn-label waves-light"
                      [ngStyle]="{'background-color': boton.class }">
                      <i class="fas {{boton.icono}} label-icon" style="pointer-events:none ;"></i>
                      {{boton.boton}}
                    </button>
                  </ng-template>
                </div>

                <!--Operaciones Especiales -->
                <div class="d-inline-block bloque mb-1" *ngIf="!mostrarModal">
                  <div ngbDropdown class="d-inline-block" *ngIf="this.toolbar[0].OPERACIONES.length > 0">
                    <button type="button" title="Procesos" class="btn blanco btn-label waves-light" ngbDropdownToggle
                      [ngStyle]="{'background-color': '#f3a462' }">
                      <i class="fas fa-solid fa-ellipsis-vertical label-icon" style="pointer-events:none ;"></i>
                      Procesos
                    </button>
                    <div ngbDropdownMenu>
                      <ng-container *ngFor="let OPERACIONES of this.toolbar[0].OPERACIONES">
                        <button *ngIf="OPERACIONES" ngbDropdownItem
                          (click)="EventoClickToolbar($event, OPERACIONES.URL)" id="{{OPERACIONES.Evento}}"
                          name="{{OPERACIONES.Evento}}"> {{OPERACIONES.boton}}</button>
                      </ng-container>

                    </div>
                  </div>
                </div>
              </ng-container>

              <div class="d-inline-block bloque mb1 ml-2" *ngIf="!mostrarModal && reportes.length > 0">
                <button *ngIf="this.tipo_pantalla !== 'REPORTE'" type="button" title="Filtrar" (click)="open()"
                  class="btn btn-info btn-label waves-light">
                  <i class="fas fa-filter label-icon" style="pointer-events:none ;"></i>
                  Filtrar
                </button>
              </div>

            </div>
          </div>
        </div>
      </div>
      <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
      <hr class="mt-1" style="border-top: 6px solid var(--app-oscuro, #0c7cb3);">
    </div>


  </div>
  <!-- END Toolbar -->


  <div class="row mb-3" *ngIf="mostrarModal && ActivarFiltro=='S'">
    <div class="col-md-12" *ngIf="form_template$">
      <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
      <div class="card mb-0" style="background-color: var(--app-muy-claro, #edf4f9);box-shadow: 0px 3px 8px;">
        <div class="card-body">
          <app-filtrocampo [form_template]="form_template$  | async" [strListener]="strEventListener"
            [blnMostrarBusqueda]="true && tipo_pantalla!='REPORTE'" [TipoPantalla]="tipo_pantalla"
            [MostrarbotonBuscar]="'true'" [Mostrartitulofiltro]="Mostrartitulofiltro" (cerrar)="cerrarmodal($event)">
          </app-filtrocampo>
        </div>
      </div>
    </div>
  </div>

  <app-alerta [SYS41ARC]="this.SYS41ARC"></app-alerta>
  
  <ng-container *ngIf="respFiltros.length > 0 && this.WsMsDataInterno == ''">
    <div ngbAccordion *ngIf="respFiltros[0].FiltrosAvanzado.length > 0" class="filtros-accordion mb-3" #acc="ngbAccordion">
      <div ngbAccordionItem [destroyOnHide]="false">
  
        <!-- Header -->
        <h6 ngbAccordionHeader class="filtros-header">
          <button ngbAccordionButton class="filtros-toggle">
            <div class="d-flex align-items-center gap-2">
              <span class="filtros-icon-wrap">
                <i class="fa fa-sliders-h"></i>
              </span>
              <span class="filtros-label">Filtros Avanzados</span>
            </div>
            <i class="fa fa-chevron-down filtros-chevron"></i>
          </button>
        </h6>
  
        <!-- Body -->
        <div ngbAccordionCollapse>
          <div ngbAccordionBody class="filtros-body">
            <ng-template>
              <div class="row mb-0">
                <div class="col-md-12">
                  <app-filtrocampo 
                    [form_template]="respFiltros"
                    [blnAccionbuscar]="blnAccionbuscar"
                    [strListener]="strEventListener"
                    [blnMostrarBusqueda]="true"
                    [TipoPantalla]="tipo_pantalla"
                    [formFiltros]="formFiltros"
                    [FiltrosAvan]="1"
                    [Mostrartitulofiltro]="Mostrartitulofiltro">
                  </app-filtrocampo>
                </div>
              </div>
            </ng-template>
          </div>
        </div>
  
      </div>
    </div>
  </ng-container>

  <!-- IFRAME para exportar datos -->
  <div class="row" *ngIf="safeURL">
    <iframe [src]="safeURL" width="0px" height="0px" style='display:hidden'>
    </iframe>
  </div>

  <div class="row mt-4" *ngIf="this.WsMsDataInterno == ''">
    <div [ngClass]="blnFiltrosAbiertos ? 'col-9' : 'col-12'">
      <div class="card" style="background-color: transparent; box-shadow: none;" *ngIf="this.tipo_pantalla !='REPORTE'">
        <div class="card-body" style="padding: 0">
          <div class="row">
            <div class="col-md-12 " *ngIf="this.tipo_pantalla=='LISTADO' ">
              <div class="row align-items-center" *ngIf="!mostrarModal">
                <div style="text-align: right;" class="offset-6 col-6">
                  <button type="button"
                    [ngClass]="this.favorito_pantalla == 'N' ? 'btn btn-light btn-label waves-light' : 'btn btn-warning btn-label waves-light'"
                    (click)="GrabarFavorito()" *ngIf="this.ActivarFavorito == 'S'" title="Favoritos">
                    <i
                      [ngClass]="this.favorito_pantalla == 'N' ? 'far fa-star label-icon ' : 'fas fa-star label-icon ' "></i>Favoritos
                  </button>
                  <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                  <button type='button' style="margin-left: 0.5em; background-color: var(--app-claro, #3ac6dd); color: var(--app-texto-claro, #fff);"
                    class="btn btn-label waves-light" (click)="BuscarAvanzado()" title="Buscar">
                    <i class="fa fa-search label-icon"></i> Buscar
                  </button>
                  <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                  <button type="button" style="margin-left: 0.5em; background-color: var(--app-claro, #35adc9); color: var(--app-texto-claro, #fff);"
                    class=" btn btn-label waves-light" (click)="limpiarbusqueda()" title="Limpiar">
                    <i class="fa fa-broom label-icon "></i> Limpiar
                  </button>
                  <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
                  <button *ngIf="this.SYS02TUT != ''" type='button' style="margin-left: 0.5em; background-color: var(--app-primario, #1f92b5);"
                    class="btn btn-label waves-light" (click)="abrirAyuda()" title="Tutorial">
                    <i class="fa fa-file-circle-question label-icon"></i> Tutorial
                  </button>
                </div>
              </div>
              <br>

              <!-- BEGIN DataTable -->
              <div class="table-responsive" style="border: 1px solid gray; border-radius: 10px;">
                <table class="table-avatar mb-0 table-striped">
                  <thead>
                    <tr>
                      <td>
                        <a class="form-check">
                          <input class="form-check-input" #chkTabla type="checkbox" (click)="checktodos($event)"
                            [value]="-1">
                        </a>
                      </td>
                      <td *ngFor="let col of ColumnasSN">
                        {{col.A03DES}}
                        <a href="javascript: void(0);" (click)="ordendes(col.A03COD)" *ngIf="!order_mostrar">
                          <i class="iconoorden fa-solid fa-arrow-up-wide-short"></i>
                        </a>
                        <a href="javascript: void(0);" (click)="ordenasc(col.A03COD)" *ngIf="order_mostrar">
                          <i class="iconoorden fa-solid fa-arrow-down-short-wide"></i>
                        </a>
                      </td>
                      <td></td>
                    </tr>
                  </thead>
                  <tbody>
                    <tr *ngIf="tableData2.length == 0;else registros">
                      <td [colSpan]="ColumnasSN.length">
                        <h5>No hay información que cumpla con los filtros indicados</h5>
                      </td>
                    </tr>

                    <ng-template #registros>
                      <tr
                        *ngFor="let table of this.tableData2 | paginate: {id:this.intSYS02CON, currentPage: currentPage, itemsPerPage: itemsPerPage } ; let i=index ">
                        <td>
                          <a class="form-check">
                            <input class="form-check-input" [checked]="table.checkado" #chkTabla type="checkbox"
                              [value]="table.INDEX">
                          </a>
                        </td>
                        <td *ngFor="let col of ColumnasSN; let j=index">
                          <div *ngIf="col.SYS03WIG == ''" (click)="EventoClickLista($event, table.INDEX)"
                            [ngClass]="{'to-right': col.SYS03TIP == 'F' || col.SYS03TIP == 'N'}">
                            {{table[col.A03COD]}}
                          </div>
                          <div *ngIf="col.SYS03WIG == 'INPUT'">
                            <input type="text" class="form-control" [(ngModel)]="table[col.A03COD]"
                              class="{{table.INDEX}}" id="{{col.A03COD}}+{{table.INDEX}}"
                              (focus)="Mostrarboton(table.INDEX)"
                              (blur)="buscardes($event,col.A03COD,table.INDEX, col.SYS03EDI, col.UrlOnChange)">
                          </div>
                        </td>
                        <td>
                            <!-- Bloque de operaciones -->
                            <ng-container *ngFor="let operacionbutton of operaciones; let i=index">
                              <button type="button" title="{{operacionbutton.boton}}"
                                *ngIf="operacionbutton.SYS16MET=='S'"
                                (click)="EventoClickOperacion(operacionbutton, 0)"
                                id="{{table.INDEX}}"
                                style="margin-left: 10px" class="btn blanco fa-sm"
                                [ngStyle]="{'background-color': operacionbutton.class }">
                                <i class="fas {{operacionbutton.icono}} label-icon"></i>
                              </button>
                            </ng-container>
                          
                            <!-- Edición en línea -->
                            <ng-container *ngFor="let operacionbutton of operaciones; let i=index">
                              <button *ngIf="operacionbutton.Evento == 'EDITAR_LINEA' && lineaEditar == table.INDEX"
                                id="{{table.INDEX}}" class="btn btn-success fa-sm"
                                (click)="EventoClickOperacion(operacionbutton, table.INDEX)" title="Guardar">
                                <i class="fa-solid fa-floppy-disk label-icon"></i>
                              </button>
                            </ng-container>
                        </td>
                      </tr>
                    </ng-template>

                  </tbody>
                </table>
              </div>
              <!-- END DataTable -->
              <div *ngIf="BottomBarData != undefined">
                <div class="card-body">
                  <table class="mb-0" style="width: 100%;text-align: right;"
                    *ngFor="let item of BottomBarData let i= index;">
                    <tr>
                      <!-- <td><h2>{{item.descripcion}} </h2></td>-->
                    </tr>
                    <tbody *ngFor="let subitem of item.cards">
                      <tr>
                        <td style="width: 94%;"> <strong> {{subitem.label}}: </strong></td>
                        <td>{{subitem.value}}</td>
                      </tr>
                    </tbody>
                  </table>
                </div>
              </div>

              <div class="row mt-3" *ngIf="tableData2.length > 0">
                <div class="offset-md-4 col-md-4">
                  <pagination-controls (pageChange)="pageChange($event)" id={{this.intSYS02CON}} autoHide="true"
                    previousLabel="Anterior" nextLabel="Siguiente" style="text-align: center;" responsive="true">
                  </pagination-controls>
                </div>
                <div class="col-md-4" style="text-align: right;">
                  <div class="dataTables_length" id="tickets-table_length">
                    <label class="d-inline-flex align-items-center">Mostrando
                      <select class="form-select" style="width:55%;" name="tickets-table_length"
                        aria-controls="tickets-table" name="pageSize"
                        class="custom-select custom-select-sm form-control mx-2"
                        (change)="countNumber($event.target.value)">
                        <option *ngFor="let number of number">
                          {{number}}
                        </option>
                      </select>
                      Registros
                    </label>
                  </div>
                </div>
              </div>
            </div>
            <!-- END LISTA DE DATOS -->
          </div>
        </div>
      </div>
    </div>


    <!-- Filtro solo para tipo de pantalla Reporte -->
    <div class="row" *ngIf="this.tipo_pantalla === 'REPORTE' ">
      <app-reportes [reportes]="this.reportes" [strListener]="this.strEventListener"
        [filtrosReporte]="this.filtrosReporte" [dashboard]="dashboard" [blnMostrarBusqueda]="tipo_pantalla=='REPORTE'"
        [SYS02CON]="this.intSYS02CON"
        [TipoPantalla]="tipo_pantalla" (AbrirNuevoNav)="AbrirReporteComponentePDFNav($event)">
      </app-reportes>
    </div>

    <label class="table__label">[{{this.intSYS02CON}}]</label>
  </div>
</div>
<app-scroll-to-top>
</app-scroll-to-top>
